import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {makeStyles} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import {useHistory} from "react-router-dom";
import {List, ListItem, ListItemSecondaryAction, ListItemText} from "@material-ui/core";
import * as actions from "../../../store/actions";
import Box from "@material-ui/core/Box";


const useStyles = makeStyles((theme) => ({
    vehicleList: {
        paddingBottom: "30px"
    },
    vehicleItem: {

        borderTop: "1px solid #96979C",
        "&.last": {
            borderBottom: "1px solid #96979C",
        },

        '& .vehicleTitle': {
            color: "#00AEEF",
            fontFamily: "Mulish",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "20px",
            lineHeight: "25px"
        },
        '& .vehicleVin': {
            fontFamily: "Mulish",
            fontStyle: "normal",
            fontSize: "16px",
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: "#FEFFFF",
            '& span': {
                fontWeight: theme.typography.fontWeightBold,
            }
        }

    }

}));


const VehicleList = (props) => {

    const classes = useStyles();
    const history = useHistory();


    const items = props.vehicles.map((vehicle, index) => {
        const lastChild = props.vehicles.length-1 === index? ' last' : ''
        return (
            <ListItem alignItems="flex-start" key={index} className={classes.vehicleItem + lastChild}>
                <ListItemText>
                    <Box className="vehicleTitle">{[vehicle.model_year, vehicle.make, vehicle.model].join(' ')}</Box>
                    <Box className="vehicleVin"><span>VIN:&nbsp;</span> {vehicle.vin}</Box>
                </ListItemText>
                <ListItemSecondaryAction>
                    <Button variant="contained" color="primary" onClick={() => {
                        // props.onSetSelectedVehicle(vehicle, () => {
                        //     history.push('/dashboard/vehicle/' + vehicle.id);
                        // });
                        props.warning.setState(true, 1);
                    }}>{'Edit'}</Button>
                </ListItemSecondaryAction>
            </ListItem>
        )
    })
    return (
        <List className={classes.vehicleList}>
            {items}
        </List>
    );
}

const mapStateToProps = state => {
    return {
        vehicles: state.vehicles
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSetSelectedVehicle: (vehicle, cb) => dispatch(actions.gatherInfo(vehicle, cb)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleList);